import { render, staticRenderFns } from "./Corr.vue?vue&type=template&id=acf8cf6a"
import script from "./Corr.vue?vue&type=script&lang=js"
export * from "./Corr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports